import React from 'react';
import { motion } from 'framer-motion';
import { FaLinkedin, FaGithub, FaEnvelope, FaPhone } from 'react-icons/fa';
import toast, { Toaster } from 'react-hot-toast';

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');

const handleSubmit = async (e) => {
  e.preventDefault();
  const name = e.target.name.value;
  const email = e.target.email.value;
  const message = e.target.message.value;

  try {
    const res = await fetch(`${API_BASE_URL}/api/send-mail`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, email, message }),
    });

    const data = await res.json().catch(() => ({}));
    if (data.success) {
      toast.success("✅ Your message has been sent!");
      e.target.reset();
    } else {
      toast.error("❌ Something went wrong!");
    }
  } catch (error) {
    console.error(error);
    toast.error("⚠️ Error sending email.");
  }
};

const Connect = () => {
  return (
    <section id="connect" className="py-24 px-6 bg-gradient-to-b from-[#0a0e1b] to-[#05070d] text-white">
      <Toaster position="top-right" />
      
      <h2 className="text-4xl font-bold text-center mb-12 bg-gradient-to-r from-neon to-highlight bg-clip-text text-transparent">
        Connect With Us
      </h2>

      <motion.form
        onSubmit={handleSubmit}
        className="max-w-3xl mx-auto bg-glass backdrop-blur-xl p-8 rounded-xl space-y-6 shadow-glow"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <div>
          <label className="block text-sm mb-2">Name</label>
          <input
            name="name"
            type="text"
            required
            className="w-full p-3 rounded bg-[#1c1f2e] text-white focus:outline-none focus:ring-2 focus:ring-neon"
          />
        </div>
        <div>
          <label className="block text-sm mb-2">Email</label>
          <input
            name="email"
            type="email"
            required
            className="w-full p-3 rounded bg-[#1c1f2e] text-white focus:outline-none focus:ring-2 focus:ring-neon"
          />
        </div>
        <div>
          <label className="block text-sm mb-2">Message</label>
          <textarea
            name="message"
            required
            className="w-full p-3 rounded bg-[#1c1f2e] text-white h-32 resize-none focus:outline-none focus:ring-2 focus:ring-neon"
          />
        </div>
        <button
          type="submit"
          className="w-full py-3 rounded-full bg-gradient-to-r from-purple-500 to-cyan-400 text-white font-semibold hover:scale-105 transition"
        >
          Send Message
        </button>
      </motion.form>

      <div className="flex justify-center mt-10 gap-6 text-xl text-white/80">
        <a href="mailto:info@masriq.tech" className="hover:text-neon transition"><FaEnvelope /></a>
        <a href="https://www.linkedin.com/company/masriqnxtech/" target="_blank" rel="noreferrer" className="hover:text-neon transition"><FaLinkedin /></a>
        <a href="https://github.com/MASRIQ-NextTech-Solutions" target="_blank" rel="noreferrer" className="hover:text-neon transition"><FaGithub /></a>
        <a href="tel:+919902806732" className="hover:text-neon transition"><FaPhone /></a>
      </div>
    </section>
  );
};

export default Connect;
